"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const styles_1 = __importDefault(require("../../styles/styles"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const expandableBox_1 = __importDefault(require("../expandableBox/expandableBox"));
const colors_1 = __importDefault(require("../../styles/colors"));
const CallFeedbackMultiSelect = ({ title, eventName, choices, mapping, selectedValues, setSelectedValues, }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    const [selectedLabels, setSelectedLabels] = react_1.useState([]);
    const checkBoxItemStyle = { marginVertical: 0, paddingVertical: 0 };
    react_1.useEffect(() => {
        // Update selected labels based on current selected values
        const labels = selectedValues.map((value) => {
            const mappedItem = mapping.get(value);
            return mappedItem && mappedItem.label ? mappedItem.label : '';
        });
        setSelectedLabels(labels);
    }, [selectedValues, mapping]);
    const toggleReason = (value) => {
        setSelectedValues((prev) => prev.includes(value) ? prev.filter((reason) => reason !== value) : [...prev, value]);
    };
    const titleBox = (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexFour, { minHeight: isDesktop ? 70 : 90 }] },
        react_1.default.createElement(boxTitle_1.default, { title: title }),
        selectedLabels.length > 0 && react_1.default.createElement(react_native_1.Text, { style: styles_1.default.marginTopTen }, selectedLabels.join(', '))));
    const choiceMidpoint = Math.ceil(choices.length / 2);
    const firstHalf = choices.slice(0, choiceMidpoint);
    const secondHalf = choices.slice(-choiceMidpoint);
    const content = (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne }, firstHalf.map(({ value, label }) => (react_1.default.createElement(react_native_1.View, { key: value },
            react_1.default.createElement(react_native_paper_1.Checkbox.Item, { label: label, status: selectedValues.includes(value) ? 'checked' : 'unchecked', onPress: () => toggleReason(value), labelStyle: styles_1.default.textColorBlack, style: checkBoxItemStyle, color: colors_1.default.BLUE }))))),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne }, secondHalf.map(({ value, label }) => (react_1.default.createElement(react_native_1.View, { key: value },
            react_1.default.createElement(react_native_paper_1.Checkbox.Item, { label: label, status: selectedValues.includes(value) ? 'checked' : 'unchecked', onPress: () => toggleReason(value), labelStyle: styles_1.default.textColorBlack, style: checkBoxItemStyle, color: colors_1.default.BLUE })))))));
    return (react_1.default.createElement(expandableBox_1.default, { withMinHeight: false, title: titleBox, expandedComponent: content, baseComponent: null, eventName: eventName }));
};
exports.default = CallFeedbackMultiSelect;
